import styled from 'styled-components';

/** Срок хранения помеченного на удаление, дни (зеркалит бэкенд RETENTION_DAYS). */
export const PTO_RETENTION_DAYS = 30;

/**
 * Сколько дней осталось до безвозвратной зачистки помеченной на удаление
 * сущности ПТО. 0 — срок истёк (вот-вот будет вычищена фоновым планировщиком).
 */
export function deletionDaysLeft(deletedAt: string | null | undefined): number {
  if (!deletedAt) return 0;
  const elapsedDays = Math.floor((Date.now() - new Date(deletedAt).getTime()) / 86_400_000);
  return Math.max(0, PTO_RETENTION_DAYS - elapsedDays);
}

/** Бейдж «помечен на удаление» (кримсон, как у статусов «на проверку»). */
export const DeletionBadge = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: ${({ theme }) => theme.radius.pill};
  color: crimson;
  border: 1px solid crimson;
  white-space: nowrap;
`;
